import React, {useState} from 'react';

export const ServicioOfrecido = (props) => {
	/* A hook that is used to set the state of the component. */
	const [EstadoInterno, setEstadoInterno] = useState('servicioOfrecido');

	/* Destructuring the props object. */
	const {nombreServicio, fotoServicio, descripCionServicio, precioServicio, cambiaEstado, num} =
		props;

	/**
	 * If the state of the internal component is "servicioOfrecido", then set the state of the internal
	 * component to "servicioOfrecidoActive", otherwise set the state of the internal component to
	 * "servicioOfrecido
	 */
	const cambiaEstadoInterno = () => {
		EstadoInterno === 'servicioOfrecido'
			? setEstadoInterno('servicioOfrecidoActive')
			: setEstadoInterno('servicioOfrecido');
		cambiaEstado(num);
	};

	return (
		<div
			className={EstadoInterno}
			onClick={cambiaEstadoInterno.bind()}
		>
			<div className='titleServicioOfrecido '>
				<div>
					<b>{nombreServicio}</b>
				</div>
			</div>
			<div className='contentServicioOfrecido'>
				<div className='fotoServicioOfrecido centrador'>
					<img src={fotoServicio} />
				</div>
				<div className='descripcionServicioOfrecido'>
					<div className='centrador'>{descripCionServicio}</div>
					<div className='subDescripcionServicioOfrecido'>
						<div className='centrador'>{precioServicio}</div>
					</div>
				</div>
			</div>
		</div>
	);
};
